import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import CropRequestsList from './components/CropRequestsList'

const CropRequests = () => {
  return (
    <Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">Crop Requests Management</h3>
          <h3 className="page-subhead subhead">View crop requests made by users so far!</h3>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <CropRequestsList />
        </Col>
      </Row>
    </Container>
  );
};

export default CropRequests;